import helpers from "../utils/helpers";

function captchaCallback() {
  grecaptcha.render("qcf-recaptcha", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: qcf.challange,
  });
}
window.captchaCallback = captchaCallback;

const qcf = {
  init: function () {
    var qcf_dom = $(".qcf");
    var qcf_message = qcf_dom.find(".qcf__message");
    var qcf_form = qcf_dom.find(".qcf__form");

    if (qcf_form.length) {
      var scrolled = $(window).scrollTop();

      $(qcf_form).on("submit", function (e) {
        e.preventDefault();
        $(".error", this).removeClass("error");

        if (helpers.validate($(this), true)) {
          window.grecaptcha.execute();
          qcf_message
            .removeClass("qcf__message-active")
            .removeClass("qcf__message-error");
        } else {
          // Status
          qcf_message.children("p").text(translations.required);
          qcf_message
            .addClass("qcf__message-active")
            .addClass("qcf__message-error");
        }
      });
    }
  },

  challange: function (token) {
    if (token) {
      qcf.submit(token);
    } else {
      grecaptcha.reset();
    }
  },

  submit: function (token) {
    var qcf_dom = $(".qcf");
    var qcf_form = qcf_dom.find(".qcf__form");
    var qcf_message = qcf_dom.find(".qcf__message");

    var nonce = qcf_form.find("#qcf-nonce").val();
    var honey = qcf_form.find("#qcf-honey").val();

    var form_data = {
      name: qcf_form.find('input[name="first-name"]').val(),
      email: qcf_form.find('input[name="email"]').val(),
      message: qcf_form.find('input[name="message"]').val(),
      case_number: qcf_form.find('input[name="case-number"]').val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_qcf",
        form_data: form_data,
        nonce: nonce,
        honey: honey,
        token: token,
      },
      beforeSend: function () {
        // Loader
        qcf_form.addClass("qcf__form-loading");
        // Status
        qcf_message.removeClass("qcf__message-active");
      },
      success: function (response) {
        // console.log(response);
        // Loader
        qcf_form.removeClass("qcf__form-loading");
        // Status
        qcf_message.children("p").text(response.data.message);

        grecaptcha.reset();

        if (response.success) {
          // Reset form and recaptcha
          qcf_form[0].reset();

          // Status
          qcf_message.removeClass("qcf__message-error");
          qcf_message
            .addClass("qcf__message-active")
            .addClass("qcf__message-success");
        } else {
          // Status
          qcf_message.removeClass("qcf__message-success");
          qcf_message
            .addClass("qcf__message-active")
            .addClass("qcf__message-error");
        }
      },
    });
  },
};

export default qcf;
